import React from "react";
import { Clock, Shield, TrendingUp, Workflow } from "lucide-react";
import { benefits } from "../data/mockData"; // see suggested copy below

const benefitIcons = [Clock, Shield, TrendingUp, Workflow];

const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Why Teams Choose
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500">
              QuillStudio
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Speed, accuracy, and a native Salesforce experience—without extra tools or code.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefitIcons[index] ?? Clock;
            return (
              <article
                key={benefit.title}
                className="group relative h-full bg-white rounded-2xl border border-slate-200/70 p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-orange-200"
              >
                {/* Icon */}
                <div className="mb-5 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-orange-100 to-pink-100">
                  <Icon aria-hidden className="text-orange-600" size={22} />
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-orange-700 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {benefit.description}
                </p>

                {/* Accent bar */}
                <span className="pointer-events-none absolute inset-x-0 -bottom-px h-1 origin-left scale-x-0 bg-gradient-to-r from-orange-400 to-pink-500 transition-transform duration-500 group-hover:scale-x-100" />
              </article>
            );
          })}
        </div>

        {/* Optional CTA under benefits */}
        <div className="text-center mt-14">
          <p className="text-sm text-slate-500 mb-3">
            Trusted by Salesforce partners and fast-moving teams
          </p>
          <a
            href="#get-started"
            className="inline-flex items-center gap-2 rounded-xl px-6 py-3 font-semibold text-white bg-gradient-to-r from-orange-500 to-pink-500 shadow-sm hover:shadow-md hover:brightness-110 transition"
          >
            Start your free trial
          </a>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
